<div class="wrapper" appMousemove>
  <app-scroll-to-top-btn></app-scroll-to-top-btn>
  <app-navigation></app-navigation>
  <div class="wrapper-container">
    <router-outlet></router-outlet>
  </div>
  <app-info></app-info>
  <app-footer></app-footer>
</div>
